import React, {FC} from 'react';

import {UnreachableError} from '../../../../../libs/shared/core/src/helpers/types/customErrors';
import {OnboardingGuideRightHalfContainer} from '../../guide/onboardingGuideRightHalfContainer';
import {OnboardingBasicsGuideBestPracticesVisual} from './onboardingBasicsGuideBestPracticesVisual';
import {OnboardingBasicsGuideChannelsIntroVisual} from './onboardingBasicsGuideChannelsIntroVisual';
import {OnboardingBasicsGuideImportMessagesVisual} from './onboardingBasicsGuideImportMessagesVisual';
import {OnboardingBasicsGuideInboxOrganizationVisual} from './onboardingBasicsGuideInboxOrganizationVisual';
import {OnboardingBasicsGuideInboxVisual} from './onboardingBasicsGuideInboxVisual';
import {OnboardingBasicsGuideRoutingVisual} from './onboardingBasicsGuideRoutingVisual';

/*
 * Constants.
 */

export enum OnboardingBasicsGuideVisualFrame {
  CHANNELS_INTRO = 'channels_intro',
  INBOXES = 'inboxes',
  ROUTING = 'routing',
  INBOX_ORGANIZATION = 'inbox_organization',
  BEST_PRACTICES = 'best_practices',
  IMPORT_MESSAGES = 'import_messages',
}

/*
 * Props.
 */

interface OnboardingBasicsGuideVisualProps {
  frame: OnboardingBasicsGuideVisualFrame;
}

/*
 * Component.
 */

export const OnboardingBasicsGuideVisual: FC<OnboardingBasicsGuideVisualProps> = (props) => (
  <OnboardingGuideRightHalfContainer>{renderFrame(props)}</OnboardingGuideRightHalfContainer>
);

function renderFrame(props: OnboardingBasicsGuideVisualProps) {
  const {frame} = props;

  switch (frame) {
    case OnboardingBasicsGuideVisualFrame.CHANNELS_INTRO:
      return <OnboardingBasicsGuideChannelsIntroVisual />;
    case OnboardingBasicsGuideVisualFrame.INBOXES:
      return <OnboardingBasicsGuideInboxVisual />;
    case OnboardingBasicsGuideVisualFrame.ROUTING:
      return <OnboardingBasicsGuideRoutingVisual />;
    case OnboardingBasicsGuideVisualFrame.INBOX_ORGANIZATION:
      return <OnboardingBasicsGuideInboxOrganizationVisual />;
    case OnboardingBasicsGuideVisualFrame.BEST_PRACTICES:
      return <OnboardingBasicsGuideBestPracticesVisual />;
    case OnboardingBasicsGuideVisualFrame.IMPORT_MESSAGES:
      return <OnboardingBasicsGuideImportMessagesVisual />;
    default:
      throw new UnreachableError(frame);
  }
}
